import FormRow from 'components/FormRow';
import FormSection from 'components/FormSection';
import { SelectWithField } from 'components/Selects/Select';
import { TextAreaWithField } from 'components/TextArea';
import { validateSectionFields } from 'modules/Inquiry/Form/formConditions';
import {
  GUARANTY_GUARANTY_REQUIREMENT,
  GUARANTY_RENTAL_DEPOSIT,
  GUARANTY_PARTIAL_RETIREMENT_ACCOUNTS,
  GUARANTY_PERFORMANCE_OF_CONTRACT,
  GUARANTY_DEPOSIT_AND_ADVANCE_PAYMENTS,
  GUARANTY_WARRANTY,
  GUARANTY_LITIGATION_BOND,
  GUARANTY_TYPE,
  GUARANTY_DESCRIPTION,
} from 'modules/Inquiry/Form/formFields';
import { AmountWithField } from 'modules/Inquiry/Form/Steps/FinancingNeed/Amount/Amount';
import { MAX_AMOUNT_VALUE } from 'modules/Inquiry/inquiry.constants';
import { InquiryType } from 'modules/Inquiry/Inquiry.type';
import { InquiryConstants } from 'schema/inquirySchema.constants';
import { FormSections } from 'schema/inquirySchema.models';
import { chooseSelectedInquiryTypeSpecificComponent } from 'shared/chooseSelectedInquiryTypeSpecificComponent';
import { useFieldValidators } from 'shared/hooks/useFieldValidators';
import { useTranslations } from 'utils/hooks/useTranslations';
import { combineValidators } from 'utils/validators';

export const validateGuarantySection = [
  validateSectionFields([GUARANTY_DESCRIPTION]),
  validateSectionFields([GUARANTY_GUARANTY_REQUIREMENT]),
];

const Guaranty = () => {
  const t = useTranslations();
  const { required, minPrice, maxPrice } = useFieldValidators();

  // Avalart: a single dropdown (EBS-38) replacing the former six type checkboxes.
  // Option values are the backend codes, so no value translation is needed on submit.
  const guarantyTypeOptions = [
    {
      value: GUARANTY_RENTAL_DEPOSIT,
      label: t('pages.financingNeed.sections.guaranty.fields.rentalDeposit.caption'),
    },
    {
      value: GUARANTY_PARTIAL_RETIREMENT_ACCOUNTS,
      label: t('pages.financingNeed.sections.guaranty.fields.partialRetirementAccounts.caption'),
    },
    {
      value: GUARANTY_PERFORMANCE_OF_CONTRACT,
      label: t('pages.financingNeed.sections.guaranty.fields.performanceOfContract.caption'),
    },
    {
      value: GUARANTY_DEPOSIT_AND_ADVANCE_PAYMENTS,
      label: t('pages.financingNeed.sections.guaranty.fields.depositAndAdvancePayments.caption'),
    },
    {
      value: GUARANTY_WARRANTY,
      label: t('pages.financingNeed.sections.guaranty.fields.warranty.caption'),
    },
    {
      value: GUARANTY_LITIGATION_BOND,
      label: t('pages.financingNeed.sections.guaranty.fields.litigationBond.caption'),
    },
  ];

  return (
    <>
      <FormSection
        title={t('pages.financingNeed.sections.guaranty.sections.guarantyRequirement')}
        name={FormSections.machine}
        sectionNumber={2}
      >
        <FormRow>
          <AmountWithField
            name={GUARANTY_GUARANTY_REQUIREMENT}
            caption={t('pages.financingNeed.sections.guaranty.fields.guarantyRequirement.caption')}
            validate={combineValidators(
              required,
              minPrice(InquiryConstants.MIN_FINANCING_AMOUNT),
              maxPrice(MAX_AMOUNT_VALUE),
            )}
          />
        </FormRow>

        <FormRow>
          <SelectWithField
            name={GUARANTY_TYPE}
            options={guarantyTypeOptions}
            caption={t('pages.financingNeed.sections.guaranty.labels.typeOfGuaranty')}
            placeholder={t('placeholders.pleaseChoose')}
            optional
          />
        </FormRow>
      </FormSection>
      <FormSection
        title={t('pages.financingNeed.sections.guaranty.sections.description')}
        name={FormSections.machine}
        sectionNumber={3}
      >
        <FormRow>
          <TextAreaWithField
            name={GUARANTY_DESCRIPTION}
            caption={t('pages.financingNeed.sections.guaranty.fields.description.caption')}
            placeholder={t('pages.financingNeed.sections.guaranty.fields.description.placeholder')}
          />
        </FormRow>
      </FormSection>
    </>
  );
};

export default chooseSelectedInquiryTypeSpecificComponent({
  [InquiryType.bfs]: Guaranty,
  default: null,
});
